import { Alert } from '@/ui/molecules/alert/Alert'

export function ConnectFromWatchWalletView() {
  // @todo: Logic later here
  return (
    <Alert variant="info">
      You are in watch wallet mode. If you want to perform actions, you need to connect your wallet.
    </Alert>
  )
}
